var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container component mt-3 px-4"},[_c('h1',{staticClass:"text-xxx-large mb-5",domProps:{"textContent":_vm._s(this.$ml.get(this.g_query_header))}}),_c('entry-table',{attrs:{"items":this.g_last_query}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }